import { AutoPayOption } from './AutoPayOption';
import { PaymentTypeEnum } from './PaymentTypeEnum';
import { PaymentProcessorEnum } from '@/common/types/AllTypesExports';

export interface InvoiceTokenData {
    billablePartyId: number;
    salesTermId: number | null;
    waiveInvoiceFee: boolean;
    taxable: boolean;
    transactionNotes: string;
    hasPaymentAddress: boolean;
}

export interface CreditCardTokenData {
    storedCardId: string;
    cardToken: string;
    nameOnCard: string;
    billingStreet: string;
    billingCity: string;
    billingState: string;
    billingZip: string;
    billingCountry: string;
    saveCard: boolean;
    autoPayOptions: AutoPayOption[];
    last4Digits: string;
    billablePartyId: number;
    autoPayOptionsJson: string;
    paymentProcessorModule: PaymentProcessorEnum | null;
    transactionNotes: string;
    selectedPaymentPlanId: number;
    hasPaymentAddress: boolean;

    // Used for stripe embeded components
    confirmationToken: string;

    // Used for 3ds 
    completedTransactionId: string;
}

export interface AchTokenData {
    storedBankAccountId: string;
    achToken: string;
    nameOnAccount: string;
    routingNumber: string;
    accountNumber: string;
    confirmAccountNumber: string;
    accountType: string;
    phone: string;
    authorizationChecked: boolean;
    saveAch: boolean;
    autoPayOptions: AutoPayOption[];
    last4Digits: string;
    billablePartyId: number;
    autoPayOptionsJson: string;
    paymentProcessorModule: PaymentProcessorEnum | null;
    transactionNotes: string;
    hasPaymentAddress: boolean;
    email: string
    billingStreet: string;
    billingCity: string;
    billingState: string;
    billingZip: string;
    billingCountry: string;

    // Used for stripe embeded components
    confirmationToken: string;
}

export interface PaymentContainerToken {
    paymentType: PaymentTypeEnum;
    invoiceTokenData: InvoiceTokenData;
    creditCardTokenData: CreditCardTokenData;
    achTokenData: AchTokenData;
    idempotencyKey: string;
    addressData: PaymentAddressData;
}

export function createPaymentContainerToken(instance?: PaymentContainerToken | any) {
    const obj = <PaymentContainerToken>{
        paymentType: PaymentTypeEnum.creditCard,
        invoiceTokenData: createInvoiceTokenData(),
        creditCardTokenData: createCreditCardTokenData(),
        achTokenData: createAchTokenData(),
        idempotencyKey: '',
        addressData: createPaymentAddressData()
    };

    if (instance) {
        Object.assign(obj, instance);
    }

    return obj;
}

export function createCreditCardTokenData(instance?: CreditCardTokenData | any) {
    const obj = <CreditCardTokenData>{
        storedCardId: '',
        cardToken: '',
        nameOnCard: '',
        billingStreet: '',
        billingCity: '',
        billingState: '',
        billingZip: '',
        billingCountry: '',
        saveCard: false,
        billablePartyId: 0,
        paymentProcessorModule: null,
        transactionNotes: '',
        confirmationToken: '',
        selectedPaymentPlanId: 0,
        hasPaymentAddress: false,
        completedTransactionId: ''
    };

    obj.autoPayOptions = [];

    if (instance) {
        Object.assign(obj, instance);
    }

    return obj;
}

export function createInvoiceTokenData(instance?: InvoiceTokenData | any) {
    const obj = <InvoiceTokenData>{
        billablePartyId: 0,
        salesTermId: null,
        waiveInvoiceFee: false,
        transactionNotes: '',
        hasPaymentAddress: false
    };

    if (instance) {
        Object.assign(obj, instance);
    }

    return obj;
}

export function createAchTokenData(instance?: AchTokenData | any) {
    const obj = <AchTokenData>{
        storedBankAccountId: '',
        achToken: '',
        nameOnAccount: '',
        routingNumber: '',
        accountNumber: '',
        confirmAccountNumber: '',
        accountType: '',
        phone: '',
        saveAch: false,
        authorizationChecked: false,
        billablePartyId: 0,
        paymentProcessorModule: null,
        transactionNotes: '',
        hasPaymentAddress: false,
        email: '',
        billingStreet: '',
        billingCity: '',
        billingState: '',
        billingZip: '',
        billingCountry: ''
    };

    obj.autoPayOptions = [];

    if (instance) {
        Object.assign(obj, instance);
    }

    return obj;
}

export interface PaymentAddressData {
    shippingStreet: string;
    shippingCity: string;
    shippingState: string;
    shippingZip: string;
    shippingCountry: string;
}
export function createPaymentAddressData(instance?: PaymentAddressData | any) {
    const obj = <PaymentAddressData>{
        shippingStreet: '',
        shippingCity: '',
        shippingState: '',
        shippingZip: '',
        shippingCountry: ''
    };
    if (instance) {
        Object.assign(obj, instance);
    }
    return obj;
}